import { toast } from 'sonner';

/** Show one toast per faction reputation change returned by the backend. */
export function toastRepChanges(repChanges) {
  (repChanges || []).forEach((rc) => {
    const sign = rc.delta > 0 ? '+' : '';
    const msg = `${rc.short} reputation ${sign}${rc.delta} → ${rc.rep} (${rc.tier})`;
    if (rc.delta > 0) toast.success(msg);
    else toast.warning(msg);
  });
}
